// Generated types for InterfacePort
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { InterfaceCategory } from '../enums';

import { PortReadAPI, PortWriteAPI } from './port';
import { PortReadAPISchemaObject, PortWriteAPISchemaObject } from './port';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface InterfacePortReadAPI extends PortReadAPI {
  /** MECHANICAL | ELECTRICAL | FLUIDIC | THERMAL | DATA_BUS. */
  category?: InterfaceCategory;
  /** Free-form spec (e.g. 'M8 bolt pattern, 4x @ 40mm PCD', 'USB 3.1 Gen 2 Type-C'). Primary human-readable description. */
  spec_text?: string;
}

export interface InterfacePortWriteAPI extends PortWriteAPI {
  /** MECHANICAL | ELECTRICAL | FLUIDIC | THERMAL | DATA_BUS. */
  category?: InterfaceCategory;
  /** Free-form spec (e.g. 'M8 bolt pattern, 4x @ 40mm PCD', 'USB 3.1 Gen 2 Type-C'). Primary human-readable description. */
  spec_text?: string;
  /** Optional reference to a Standard catalog entry. */
  standard?: string;
  /** Boundary INTERFACE Requirements this port is responsible for (exposed connector; no Connection exists — the other end is outside the system). */
  satisfies?: string[];
  /** The LogicalPart or Part that owns this InterfacePort. */
  owner?: string;
  /** Ancestor LPs/PPs that surface this InterfacePort (same layer as owner). */
  bound_to?: string[];
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const InterfacePortReadAPISchema: z.ZodType<InterfacePortReadAPI> = PortReadAPISchemaObject.extend({
  category: z.nativeEnum(InterfaceCategory).optional(),
  spec_text: z.string().optional(),
}).passthrough();

export const InterfacePortWriteAPISchema: z.ZodType<InterfacePortWriteAPI> = PortWriteAPISchemaObject.extend({
  category: z.nativeEnum(InterfaceCategory).optional(),
  spec_text: z.string().optional(),
  standard: z.string().optional(),
  satisfies: z.array(z.string()).optional(),
  owner: z.string().optional(),
  bound_to: z.array(z.string()).optional(),
}).passthrough();
